<div class="main-content">
    <div class="parentContainer">
     <!-- <h1>about Us</h1> -->
      <div class="bannerContainer">
        <picture>
  
          <source media="(max-width:768px)" srcset="{{environment?.blobUrl}}/assets/images/aboutUs/about-us-mob-banner.webp">
          <img  loading="lazy" [src]="environment?.blobUrl+'/assets/images/aboutUs/about-us-banner.webp'" alt="About Us Banner | Luminous">
        </picture>
      </div>
  
      <div class="container">
        <div class="tagLineContainer">
          <div class="row">
            <div class="col-12 col-md-6 tagLine">
              <h1>
                What we do
              </h1>
            </div>
            <div class="col-12 col-md-6 description">
              <p class="heading4">Luminous Power Technologies is a powerful and trustworthy brand with a wide range of
                innovative products in the power backup, and residential solar space.</p>
              <p class="heading4">With 7 manufacturing units, more than 28 sales offices in India and presence in over 36
                countries, our 6000 employees serve more than 60,000 channel partners and millions of customers. Our motto
                has always been Customer Delight through Innovation & Passion with the focus on Execution & Team-work. At
                Luminous, we passionately innovate to make life comfortable and efficient.</p>
            </div>
          </div>
        </div>
      </div>
      <div class="core-values">
        <div class="container">
          <div class="core-raw" *ngIf="aboutData != null && aboutData != '' && aboutData != undefined">
            <div class="core-col" *ngFor="let data of aboutData">
              <img  loading="lazy" [src]="data.image"
              [alt]="data.imageAltTag">
              <h5 class="heading5">{{data.heading}}</h5>
              <p>{{data.heading}}</p>
              <a class="arrow" [routerLink]="data.webURL">Learn More</a>
            </div>
             </div>
        </div>
      </div>
  
      <div class="ourJourney">
        <div class="container">
          <h2 class="subHeading heading3">Our Journey</h2>
          <div class="yearContainer" *ngIf="ourJourney != null && ourJourney != '' && ourJourney != undefined">
            <div class="years" *ngFor="let journeyData of ourJourney;let i=index"
              [ngClass]="{'selectedYear':i == selectedYearIndex}">
              <label class="year heading4" (click)="yearHandler(i)">{{journeyData.year}}</label>
              <div class="line" [ngClass]="{'height0': i == (ourJourney.length - 1) }">
                <img *ngIf="i != selectedYearIndex"  loading="lazy" [src]="environment?.blobUrl+'/assets/images/aboutUs/ellipse.svg'" alt="Ellipse | Lumious">
                <img *ngIf="i != selectedYearIndex"  loading="lazy" [src]="environment?.blobUrl+'/assets/images/aboutUs/ellipse.svg'" alt="Ellipse | Lumious"
                  (click)="yearHandler(i)">
                <img *ngIf="i == selectedYearIndex" class="cursorNone"  loading="lazy" [src]="environment?.blobUrl+'/assets/images/aboutUs/ellipseBlue.svg'">
                <img *ngIf="i == selectedYearIndex" class="cursorNone"  loading="lazy" [src]="environment?.blobUrl+'/assets/images/aboutUs/ellipseBlue.svg'"
                  alt="EllipseBlue | Luminous">
              </div>
              <div *ngIf="i == selectedYearIndex" class="selectedYearData">
                <img  loading="lazy" [src]="environment?.blobUrl+'/assets/images/aboutUs/passThrough.svg'" alt="Pass | Luminous">
                <img  loading="lazy" [src]="environment?.blobUrl+'/assets/images/aboutUs/passThrough.svg'" alt="Pass | Luminous">
                <p class="heading4">{{selectedYearData.heading}}</p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="whyLuminous">
        <div class="container">
          <h3 class="subHeading heading3">Luminous Facts</h3>
          <div class="row" *ngIf="whyLuminous != null && whyLuminous != '' && whyLuminous != undefined">
            <div class="col-6 col-md-3 tiles" *ngFor="let data of whyLuminous">
              <div class="tileData">
                <h3 class="title">{{data.title}}</h3>
                <p>{{data.subTitle}}</p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="leadersContainer">
        <div class="container">
          <h3 class="subHeading heading3">Meet Our Leaders</h3>
          <app-carousal-page [isOurLeaderCarousel]="true"  [carouselSlideData]="leaders">
          </app-carousal-page>
        </div>
      </div>
      <div class="achievementContainer">
        <div class="container">
          <h3 class="subHeading heading3">Achievements</h3>
          <div *ngIf="utils.screenSizeObj.width>=768" >
            <app-carousal-page [genericCarousel]="false" [carouselSlideData]="achievementData">
            </app-carousal-page>
          </div>
          <div *ngIf="utils.screenSizeObj.width<768 && achievementData != null && achievementData != undefined && achievementData != ''" class="dataContainer">
            <div class="slides" *ngFor="let slide of achievementData; let i=index" [hidden]="(i > 3) && !showAchievement">
              <img loading="lazy" [src]="slide.icon" [alt]="slide.icon">
              <p class="title heading5">{{slide.title}}</p>
              <p class="description">{{slide.description}}</p>
            </div>
            <div class="text-center mt-5">
              <a class="nextLinkWithArrow" *ngIf="!showAchievement" (click)="achievementHandler(true)">view
                more </a>
              <a class="prevLinkWithArrow" *ngIf="showAchievement" (click)="achievementHandler(false)">view
                less</a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  